
import { useDispatch } from 'react-redux';
import { setfreeTextFareRules, setstructuredFareRules } from '../actionCreators/penaltiesTab';

export function ResetPenaltiesTab() {
    const dispatch = useDispatch();

    dispatch(setfreeTextFareRules([]));
    dispatch(setstructuredFareRules([]));
}